import { cn } from '@/lib/utils';
import type { DataTableCellTone } from '@shared/types/views';

const TONE_CLASS: Record<DataTableCellTone, string> = {
  good: 'bg-[var(--domino-good)]',
  warning: 'bg-[var(--domino-warning)]',
  critical: 'bg-[var(--domino-critical)]',
  neutral: 'bg-domino-inkSoft/50',
};

/** Colored dot that reads a value at a glance; the text next to it carries the meaning. */
export const ToneDot = ({ tone, hollow = false, className }: { tone: DataTableCellTone; hollow?: boolean; className?: string }) => (
  <span
    aria-hidden="true"
    className={cn('inline-block h-2 w-2 shrink-0 rounded-full', hollow ? 'border-2 border-current bg-domino-white' : TONE_CLASS[tone], className)}
  />
);
